const finiteNumber = value =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

const countOfLimit = (count, limit) => ({
  count: finiteNumber(count),
  limit: finiteNumber(limit)
});

const shipmentsOf = restrictions => {
  const {count, limit} = countOfLimit(
    restrictions && restrictions.shipped_current,
    restrictions && restrictions.max_allowed
  );
  const percent =
    count !== null && limit !== null && limit > 0
      ? Math.round((count / limit) * 100)
      : null;
  return {count, limit: limit === 0 ? null : limit, percent};
};

const textOrNull = value =>
  typeof value === 'string' && value.trim() !== '' ? value : null;

const buildHeaderModel = (settings, show) => {
  const tenant = (show && show.tenant) || {};
  const basicinfo = tenant.basicinfo || {};
  const planLimits = (settings && settings.plan_limits) || {};
  const userCounts = (settings && settings.user_counts) || {};
  const tenantSettings = (settings && settings.tenant_settings) || {};
  const subscription = tenant.subscription_info || {};

  return {
    name: textOrNull(basicinfo.name),
    url: textOrNull(basicinfo.url),
    deleted: Boolean(basicinfo.deleted_at),
    testTenant:
      typeof tenantSettings.test_tenant_toggle === 'boolean'
        ? tenantSettings.test_tenant_toggle
        : null,
    plan: textOrNull(subscription.plan),
    regularUsers: countOfLimit(userCounts.regular, planLimits.num_users),
    adminOnlyUsers: countOfLimit(
      userCounts.administrative,
      planLimits.administrative_users
    ),
    shipments: shipmentsOf(tenant.access_restrictions_info),
    stores: Array.isArray(settings && settings.stores)
      ? settings.stores.length
      : null,
    note: 'note' in basicinfo ? textOrNull(basicinfo.note) || '' : null,
    scheduledImportToggle: tenantSettings.scheduled_import_toggle,
    inventoryReportToggle: tenantSettings.inventory_report_toggle
  };
};

export default buildHeaderModel;
